import { getSoketiAppKey } from '../helpers/getEnvConfig';

export const SOKETI_APP_KEY = getSoketiAppKey();
export const SOKETI_CLUSTER = 'mt1';
export const SOKETI_DEFAULT_WS_PORT = 443;
export const SOKETI_DEFAULT_WSS_PORT = 443;

export const SOKETI_AUTH_ENDPOINT = '/api/soketi/auth';

// Channel Prefixes
export const DEVICE_CHANNEL_PREFIX = 'device.';
export const SPACE_CHANNEL_PREFIX = 'space.';
export const FLOOR_CHANNEL_PREFIX = 'floor.';
export const LOCATION_CHANNEL_PREFIX = 'location.';
export const SPACE_GROUP_CHANNEL_PREFIX = 'space_group.';
export const SPACE_TYPE_CHANNEL_PREFIX = 'space_type.';

// Device Events
export const DEVICE_EVENTS = {
    CONFIG_UPDATED: 'device.updated',
    ACTION_AUTHORIZED: 'device.action_authorized',
    DELETED: 'device.deleted',
    FORCE_DISCONNECT: 'device.force_disconnect',
    DISCONNECT: 'device.disconnect',
    RESTART: 'device.reload'
};

// Booking Events (on space channels)
export const BOOKING_EVENTS = [
    'booking.created',
    'booking.updated',
    'booking.cancelled',
    'booking.check-in',
    'booking.check-out',
    'booking.no-show'
];

// Location Events
export const LOCATION_EVENTS = {
    UPDATED: 'location.updated'
};

// Maintenance Events (on space, floor, and location channels)
export const MAINTENANCE_EVENTS = {
    UPDATED: 'maintenance.updated'
};

// Space Group Events
export const SPACE_GROUP_EVENTS = {
    UPDATED: 'space_group.updated'
};

// Space Type Events
export const SPACE_TYPE_EVENTS = {
    UPDATED: 'space_type.updated'
};

// Connection States
export const CONNECTION_STATES = {
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
    CONNECTING: 'connecting',
    DISCONNECTING: 'disconnecting'
};

// EventBus Events (for internal communication)
export const INTERNAL_EVENTS = {
    SOKETI_CONNECTED: 'soketiConnected',
    SOKETI_DISCONNECTED: 'soketiDisconnected',
    SOKETI_ERROR: 'soketiError'
};

// Booking Interval Configuration
export const BOOKING_INTERVAL_CONFIG = {
    CHECK_INTERVAL_MS: 10 * 1000, // Check every 10 seconds
    EARLY_CHECKIN_DURATION: 15 // 15 minutes before booking start
};

export const MAINTENANCE_INTERVAL_CONFIG = {
    CHECK_INTERVAL_MS: 60 * 1000, // Check every minute
    FETCH_INTERVAL_MS: 24 * 60 * 60 * 1000 // Fetch every 24 hours
};